import { Banner } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';

/**
 * Shown when the server returns 401 to an authenticated fetch. We do a
 * TOP-LEVEL redirect (`window.top.location`) to /api/auth — never a same-frame
 * redirect, because the app is embedded in the Shopify admin iframe and a
 * same-frame redirect would trigger X-Frame-Options/CSP blockers.
 */
export function ReconnectBanner({ shop }: { shop: string | null }): JSX.Element {
  const { t } = useTranslation();
  const href = shop ? `/api/auth?shop=${encodeURIComponent(shop)}` : '/api/auth';
  return (
    <Banner
      title={t('banners.reconnectTitle')}
      tone="warning"
      action={{
        content: t('banners.reconnectAction'),
        onAction: () => {
          // window.top may be null when opened via popup; fallback to self.
          const top = window.top ?? window;
          top.location.href = href;
        },
      }}
    >
      <p>{t('banners.reconnectBody')}</p>
    </Banner>
  );
}
